import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { FAQS } from "@/data/site";

export default function FAQ() {
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" className="relative py-20 sm:py-28" data-testid="faq-section">
      <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-10">
        <div className="text-center max-w-2xl mx-auto">
          <Reveal className="flex items-center justify-center gap-2 text-azo-primary font-mono2 text-xs uppercase tracking-widest mb-4">
            <span className="h-px w-8 bg-azo-primary" /> Frequently asked
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="font-heading font-extrabold tracking-tight text-3xl sm:text-5xl leading-[1.05]">
              Aapke sawaal, hamare jawab
            </h2>
          </Reveal>
        </div>

        <div className="mt-12 space-y-3">
          {FAQS.map((f, i) => {
            const isOpen = open === i;
            return (
              <Reveal key={i} delay={i * 0.05}>
                <div
                  className={`rounded-2xl border bg-azo-surface transition-colors duration-300 ${
                    isOpen ? "border-azo-primary" : "border-azo-border"
                  }`}
                  data-testid={`faq-item-${i}`}
                >
                  <button
                    onClick={() => setOpen(isOpen ? -1 : i)}
                    className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left"
                    aria-expanded={isOpen}
                  >
                    <span className="font-heading font-semibold text-base sm:text-lg">{f.q}</span>
                    <span
                      className={`grid h-8 w-8 shrink-0 place-items-center rounded-full transition-all duration-300 ${
                        isOpen ? "bg-azo-primary text-white rotate-45" : "bg-azo-primary/10 text-azo-primary"
                      }`}
                    >
                      <Plus size={18} />
                    </span>
                  </button>
                  <AnimatePresence initial={false}>
                    {isOpen && (
                      <motion.div
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: "auto", opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
                        className="overflow-hidden"
                      >
                        <p className="px-6 pb-6 -mt-1 text-azo-muted leading-relaxed">{f.a}</p>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
